module.exports = "pegasus_template/assets/two-column-image-text-preview.png";